import React, { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import axios from "axios";

import { Header /* StatsPanel */ } from "../components";
import routes from "../routes/routes";
import { useHistory } from "react-router-dom";
import { withAuthHeader } from "../routes/authRequest";

const AddSection = () => {
    const { register, handleSubmit, errors } = useForm();
    const [message, setMessage] = useState("");
    const mutation = useMutation(sectionData => withAuthHeader.post(routes.api.locations.addSections, sectionData))
    const history = useHistory()

    const onSubmit = async (inputData) => {
        await mutation.mutate(inputData, {
            onSuccess: async (inputData) => {
                setMessage(["Section Added"])
                console.log("response", inputData);
                setTimeout(() => {
                    history.push(routes.public.sections)
                }, 2000);

            },
            onError: async (error) => {
                setMessage(["Something went wrong, please try again"])
            },
        })
        console.log(inputData);
    };
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header title="Add Section" />

            <div className="contentpanel">

                <div className="col-md-10 col-md-offset-1">
                    <form className="panel panel-default" onSubmit={handleSubmit(onSubmit)}>
                        <p className="text-success">{message[0]}</p>

                        <div className="panel-heading">
                            <div className="panel-btns">
                                <a
                                    href="/#"
                                    className="panel-minimize tooltips"
                                    data-toggle="tooltip"
                                    title="Minimize Panel"
                                >
                                    <i className="fa fa-minus">-</i>
                                </a>
                                <a
                                    href="/#"
                                    className="panel-close tooltips"
                                    data-toggle="tooltip"
                                    title="Close Panel"
                                >
                                    <i className="fa fa-times"></i>
                                    X
                </a>
                            </div>
                            {/* <!-- panel-btns --> */}
                            <h4 className="panel-title">Create Event</h4>
                            <p>Add a new Section by filling and submitting the form.</p>
                        </div>
                        {/* <!-- panel-heading --> */}
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        className="form-control"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="name"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>

                                <div className="form-group col-md-6">
                                    <label>Category</label>
                                    <input
                                        type="text"
                                        name="category"
                                        placeholder="Category"
                                        defaultValue="sport"
                                        className="form-control"
                                        ref={register()}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="category"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label>Price</label>
                                    <input
                                        type="text"
                                        name="price"
                                        placeholder="Price"
                                        className="form-control"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="price"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                            </div>
                            {/* <!-- row --> */}

                            <label>Description</label>
                            <textarea
                                className="form-control"
                                name="description"
                                rows="5"
                                placeholder="Description"
                                ref={register({
                                    required: "This input is required.",
                                    minLength: {
                                        value: 10,
                                        message: "This input must exceed 10 characters",
                                    }
                                })}
                            ></textarea>
                            <ErrorMessage
                                errors={errors}
                                name="description"
                                render={(messages) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p className="text-danger">{message}</p>
                                        ))
                                        : null;
                                }}
                            />
                        </div>
                        {/* <!-- panel-body --> */}
                        <div className="panel-footer">
                            <button type="submit" className="btn btn-primary">Add Event</button>
                        </div>
                        {/* <!-- panel-footer --> */}
                    </form>
                    {/* <!-- panel --> */}
                </div>
            </div>
        </div>
    );
};

export default AddSection;
